import React, {useEffect, useState} from 'react'
import ReactEcharts from 'echarts-for-react'
import Moment from 'moment'
import ApiRequest from 'EurestoApi/ApiRequest'
import project from 'EurestoConfig/project.config'
import {Grid} from '@material-ui/core'

import {extendMoment} from 'moment-range'

const moment = extendMoment(Moment)

moment.locale('fr')

export default React.memo(props => {

  const [dataSeriesBar, setDataSeriesBar] = useState([])
  const [loading, setLoading] = useState(true)
  const [selected, setSelected] = useState(props.barData && props.barData.map((el, i) => ({ [el.title]: true })).reduce((a, b) => ({ ...a, ...b }), {}))

  useEffect(() => {
    setLoading(true)
    generateBarData().then(r => setLoading(false))
  }, [props.date_debut])

  const getOptionsBar = () => {
    return (
      {
        legend: {
          selected: selected,
          show: false
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
          }
        },
        xAxis: props.barData && props.barData.map((el, i) => ({
          id: i,
          data: props.year &&
            Array.from(moment.range(props.date_debut, props.date_fin).by('months')).map(m => m.format('MMM'))
            || Array.from(moment.range(props.date_debut, props.date_fin).by('days')).map(m => m.format('ddd DD')),
          position: 'bottom',
        })),
        yAxis: {
          minInterval: 1,
          splitArea: { show: false }
        },
        series: dataSeriesBar
      }
    )
  }

  const generateSeries = (tab) => {
    const series = tab.filter(el => !el.accumulation).sort((a, b) => b.nb - a.nb).map((el, i) => {
      let data = (props.year &&
        Array.from(moment.range(props.date_debut, props.date_fin).by('months'))
        || Array.from(moment.range(props.date_debut, props.date_fin).by('days'))).map(r => 0)
      data[el.index] = el.nb
      return {
        name: el.label,
        type: 'bar',
        data: data,
        barGap: '-100%',
        barWidth: '80%',
        zlevel: i+2,
        itemStyle: {
          color: el.color,
        },
        emphasis: {
          barBorderWidth: 1,
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          shadowColor: 'rgba(0,0,0,0.5)'
        }
      }
    })

    const seriesAccumulated = props.barData.map((el, i) => tab.filter(bar => bar.accumulation && bar.label === el.title)).filter(el => el.length > 0)
    series.push(
      ...seriesAccumulated.map((el, index) => ({
          name: el[0].label,
          type: 'line',
          data: el.map(e => e.nb),
          zlevel: 1,
          itemStyle: {
            color: el[0].color,
          },
          emphasis: {
            barBorderWidth: 1,
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowColor: 'rgba(0,0,0,0.5)'
          }
        }
      ))
    )
    return series
  }

  const listBarType = async (element) => {
    let param = {
      recherche: element.recherche,
    }
    param.recherche.push({
      'champ': element.champ_recherche || props.champ_recherche || 'date_reservation',
      'operation': element.accumulation && 'lte' || 'between',
      'valeur': element.accumulation && props.date_fin || [props.date_debut, props.date_fin]
    })
    let res = await ApiRequest(project.api + props.module, {
      requete: props.requete,
      action: 'list',
      ...param
    })
    let dates = Array.from(moment.range(props.date_debut, props.date_fin).by(props.year && 'months' || 'days'))
    return dates.map((date, index) => ({
      label: element.title,
      color: element.color,
      index: index,
      accumulation: element.accumulation,
      nb: element.filter ? res.results.filter(o => element.filter(o, date)).length : res.results.filter(o => moment(o[element.champ_recherche || props.champ_recherche]).isSame(date, props.year && 'month' || 'day')).length,
      date: date
    }))
  }

  const generateBarData = async () => {
    let formatData = (await Promise.all(props.barData.map(async (el) => listBarType(el)))).reduce((a,b) => [...a, ...b], [])
    let series = generateSeries(formatData)
    setDataSeriesBar(series)
  }

  return <Grid container direction={'column'} justify={'center'} alignItems={'center'} spacing={0}
               style={{ margin: 0, padding: 0 }}>
    <ReactEcharts option={getOptionsBar()} opts={{ renderer: 'svg' }} style={{ width: '100%' }}
                  showLoading={loading} lazyUpdate/>
    <Grid container direction={'row'} spacing={0} style={{ margin: 0, padding: 0, width: '100%' }} justify={'center'}
          alignItems={'center'}>
      {
        props.barData && props.barData.map(b =>
          <Grid item spacing={0} style={{ margin: 0, padding: 5, cursor: 'pointer' }} onClick={_ => {
            const selecs = EurestoClone(selected)
            if (Object.values(selected).reduce((a, b) => a && b, true) || !selecs[b.title]) {
              Object.keys(selected).map(key => {
                if (key !== b.title) {
                  selecs[key] = false
                }
              })
              selecs[b.title] = true
            } else {
              Object.keys(selected).map(key => selecs[key] = true)
            }
            setSelected(selecs)
          }}>
            <Grid container direction={'row'} spacing={0} style={{
              margin: 0,
              padding: 0,
              width: '100%',
              color: !selected[b.title] && 'lightgray' || 'black',
              fontWeight: !selected[b.title] && 'normal' || 'bold'
            }}
                  justify={'center'} alignItems={'center'}>
              <div
                style={{
                  display: 'inline-block',
                  width: 25,
                  height: 10,
                  borderRadius: 3,
                  backgroundColor: !selected[b.title] && 'lightgray' || b.color
                }}/>
              &nbsp;{b.title}
            </Grid>
          </Grid>)
      }
    </Grid>

  </Grid>
})



// WEBPACK FOOTER //
// ./app/Components/WidgetBar.js